import React from "react"

export default function ContactHomeSection({ children }) {
  return (
    <section id="contact">
      <div className="container">{children}</div>
    </section>
  )
}
